module.exports = __webpack_public_path__ + "41c334458275363d36fe12b98f78516b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-0.png
// module id = 2653
// module chunks = 0